import { styled, Switch } from '@mui/material';
import React, { FC, useCallback, useMemo } from 'react';

interface IIconSwitchProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	checkedIcon: React.ReactElement;
	uncheckedIcon: React.ReactElement;
	'data-testid'?: string;
}

const IconSwitch: FC<IIconSwitchProps> = ({
	checked,
	onChange,
	checkedIcon,
	uncheckedIcon,
	'data-testid': dataTestId = 'icon-switch'
}) => {
	const MaterialUISwitch = useMemo(
		() =>
			styled(Switch)(({ theme }) => ({
				width: 55,
				height: 34,
				padding: 7,
				'& .MuiSwitch-switchBase': {
					margin: 1,
					padding: 0,
					transform: 'translateX(4px) translateY(4px)',
					'&.Mui-checked': {
						transform: 'translateX(25px) translateY(4px)',
						'& + .MuiSwitch-track': {
							opacity: 1,
							backgroundColor: theme.palette.grey['300']
						}
					}
				},
				'& .MuiSvgIcon-root': {
					padding: 2,
					color: theme.palette.primary.contrastText,
					backgroundColor: theme.palette.primary.main,
					borderRadius: '100%'
				},
				'& .MuiSwitch-track': {
					opacity: 1,
					backgroundColor: theme.palette.grey['300'],
					borderRadius: 20 / 2
				}
			})),
		[] // eslint-disable-line -- we don't want to listen to icon changes to avoid extra renders
	);

	const onChangeSwitch = useCallback(
		() => onChange(!checked),
		[checked, onChange]
	);

	return (
		<MaterialUISwitch
			data-testid={dataTestId}
			checked={checked}
			onChange={onChangeSwitch}
			checkedIcon={checkedIcon}
			icon={uncheckedIcon}
		/>
	);
};

export default IconSwitch;
